export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  NATURE: "NATURE",
};

export default class constants {
  public static CustomerTypeID = 1;
  public static apiCallLimit = 80;
  public static graphAnimation = 0;
  public static defaultTerms = 12;
  public static FEEDBACK_URL =
    "https://bkvenergy.com/wp-json/contact-form-7/v1/contact-forms/98/feedback";
  public static _wpcf7_locale = "en_US";
  public static _wpcf7_unit_tag: string = "wpcf7-f98-o1";
  public static _wpcf7_ak_js: number = 1693550488020;
  public static _wpcf7 = 98;
  public static _wpcf7_container_post = 0;
  public static routeToPlan = "bluebonnet-vs-Polyedra";
  public static enrollment_link =
    "https://enroll.bkvenergy.com/?ZipCode=77077&promo=SEOEIQ0001";
}

export const competitorArray1 = [
  "bluebonnet-vs-ev-charging",
  "bluebonnet-vs-free-nights-weekends",
  "bluebonnet-vs-base-fees",
  "bluebonnet-vs-bill-credit",
  "bluebonnet-vs-bullseye",
];

export const competitorArray2 = [
  "bluebonnet-vs-Paintbrush",
  "bluebonnet-vs-Primrose",
  "bluebonnet-vs-Polyedra",
  "bluebonnet-vs-Pepper-Tree",
  "bluebonnet-vs-Agave",
];
